export class TblQuickSet {
  id?: number;
  empId?: number;
  quickSetData?: string;

  constructor(id: number, empId: number, quickSetData: string) {
    this.id = id;
    this.empId = empId;
    this.quickSetData = quickSetData;
  }
}
